export default "/images/vendor/flag-icons/flags/1x1/sd.svg?e0516e5be772a548898b7e0b601a4d09";